/**
 * Action Categories and Subcategories for Preventive & Corrective Measures
 * Used for organizing and categorizing remediation actions in postmortems
 */

export const ACTION_CATEGORIES = [
  {
    label: "People",
    options: [
      { value: "people_training_awareness", label: "Training & Awareness" },
      { value: "people_roles_responsibilities", label: "Roles & Responsibilities" },
      { value: "people_staffing_oncall", label: "Staffing & On-call Coverage" }
    ]
  },
  {
    label: "Process",
    options: [
      { value: "process_sop_runbook", label: "SOP / Runbook Updates" },
      { value: "process_escalation_communication", label: "Escalation & Communication Flow" },
      { value: "process_change_management", label: "Change Management & Governance" },
      { value: "process_compliance_policy", label: "Compliance & Policy Alignment" }
    ]
  },
  {
    label: "Technology",
    options: [
      { value: "technology_app_code_fixes", label: "Application / Code Fixes" },
      { value: "technology_infrastructure_capacity", label: "Infrastructure & Capacity Improvements" },
      { value: "technology_database_storage", label: "Database & Storage Maintenance" },
      { value: "technology_network_connectivity", label: "Network & Connectivity Enhancements" },
      { value: "technology_security_hardening", label: "Security Hardening" }
    ]
  },
  {
    label: "Monitoring & Detection",
    options: [
      { value: "monitoring_alert_tuning", label: "Alert Tuning & Noise Reduction" },
      { value: "monitoring_observability", label: "Observability Improvements (Metrics, Logs, Traces)" },
      { value: "monitoring_synthetic_tests", label: "Synthetic Tests & Health Checks" }
    ]
  },
  {
    label: "Automation",
    options: [
      { value: "automation_self_healing", label: "Self-Healing Scripts" },
      { value: "automation_deployment", label: "Deployment Automation" },
      { value: "automation_routine_tasks", label: "Routine Task Automation" }
    ]
  },
  {
    label: "Documentation & Knowledge",
    options: [
      { value: "documentation_rca_quality", label: "RCA Quality & Completeness" },
      { value: "documentation_knowledge_base", label: "Knowledge Base Updates" },
      { value: "documentation_lessons_learned", label: "Lessons Learned Repository" }
    ]
  },
  {
    label: "Governance & Compliance",
    options: [
      { value: "governance_audit_risk", label: "Audit & Risk Controls" },
      { value: "governance_vendor_slas", label: "Vendor / Third-Party SLAs" },
      { value: "governance_regulatory", label: "Regulatory Requirements" }
    ]
  },
  {
    label: "Customer / Business Impact",
    options: [
      { value: "customer_stakeholder_comms", label: "Stakeholder Communication" },
      { value: "customer_status_updates", label: "Status Page / Incident Updates" },
      { value: "customer_blast_radius", label: "Blast Radius Minimization" }
    ]
  }
];

/**
 * Horizontal/Vertical Fix Type Options
 */
export const HORIZONTAL_VERTICAL_FIX_OPTIONS = [
  { value: "horizontal", label: "Horizontal" },
  { value: "vertical", label: "Vertical" },
  { value: "both", label: "Both" },
  { value: "not_applicable", label: "Not Applicable" }
];

/**
 * Helper function to get label from value
 */
export const getActionCategoryLabel = (value) => {
  for (const category of ACTION_CATEGORIES) {
    const option = category.options.find(opt => opt.value === value);
    if (option) return option.label;
  }
  return value;
};

/**
 * Helper function to get all subcategory options as flat array
 */
export const getAllActionCategoryOptions = () => {
  return ACTION_CATEGORIES.flatMap(category => category.options);
};
